// extracted by mini-css-extract-plugin
export var standaloneTable = "_fq-0";
export var standaloneTableWithBodyFill = "_fq-1";
export var withExtraHeader = "_fq-2";